import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Link as ScrollLink, scroller } from "react-scroll";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleContactClick = () => {
    if (location.pathname === "/") {
      // Already on home → scroll down
      scroller.scrollTo("contact-section", {
        smooth: true,
        offset: -60,
        duration: 600,
      });
    } else {
      // Navigate home and scroll after render
      navigate("/", { state: { scrollToContact: true } });
    }
    setIsOpen(false); // close mobile menu if open
  };

  return (
    <nav className="bg-gray-900 text-white shadow-lg fixed w-full top-0 left-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          {/* Logo */}
          <Link
            to="/"
            className="text-xl font-bold tracking-wide hover:text-indigo-400"
          >
            VirtualKeyboard
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex space-x-8">
            <Link to="/" className="hover:text-indigo-400 transition">
              Home
            </Link>
            <Link to="/keyboard" className="hover:text-indigo-400">
              Preview
            </Link>
            <Link to="/about" className="hover:text-indigo-400 transition">
              About
            </Link>
            <Link to="/howtouse" className="hover:text-indigo-400 transition">
              Guide
            </Link>

            {/* Contact Button */}
            <span
              onClick={handleContactClick}
              className="cursor-pointer hover:text-indigo-400 transition"
            >
              Contact
            </span>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="p-2 rounded-md hover:bg-gray-800"
            >
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isOpen && (
        <div className="md:hidden bg-gray-800 px-4 py-3 space-y-3">
          <Link to="/" className="block hover:text-indigo-400" onClick={() => setIsOpen(false)}>
            Home
          </Link>
          <Link to="/about" className="block hover:text-indigo-400" onClick={() => setIsOpen(false)}>
            About
          </Link>
          <Link to="/keyboard" className="block hover:text-indigo-400" onClick={() => setIsOpen(false)}>
            Preview
          </Link>
          <Link to="/howtouse" className="block hover:text-indigo-400" onClick={() => setIsOpen(false)}>
            Guide
          </Link>
          <span
            onClick={handleContactClick}
            className="block cursor-pointer hover:text-indigo-400"
          >
            Contact
          </span>
        </div>
      )}
    </nav>
  );
}
